module.exports = __webpack_public_path__ + "static/zdjęcia15-707fb11ada5fec38f8cf457d4df69fd7.svg";